import { Config, Helpers, InitializeTypes } from '@smiles/core-engine';
import type { APIEnvs } from '@smiles/core-engine/dist/types';

const WINDOW = window;
let smlsEnv = WINDOW.smlsEnv;

if (smlsEnv?.includes('uat')) {
  smlsEnv = smlsEnv.replace(/uat/, 'hml');
}

const ENV_CORE = (`${smlsEnv?.toLocaleUpperCase() + (WINDOW.isDotEnv ? '-N' : '')}` || 'MOCK') as APIEnvs;
WINDOW.envCore = ENV_CORE;

export const constants: any = {};

export const googleMapKey = () => {
  const KEY_CONSTANT = 'hoteis';
  const constant = Helpers.getConstants(KEY_CONSTANT) as { googleMapsKey?: string };
  return constant?.googleMapsKey ?? '';
};

const initCore = async () => {
  const config: InitializeTypes = {
    service: {
      logger: false,
      timeout: 60000,
      environment: ENV_CORE,
      region: 'Brasil',
    },
    globalMocks: {
      lstApis: [],
    },
    channel: 'WEB',
    loggerXstate: false,
  };

  await Config.initialize(config);
  constants.mapKey = googleMapKey();
};

const saveAuthToken = async (token: string | null) => {
  if (token) {
    Config.saveTokenAuthUser({ accessToken: token });
  }
};

export { initCore, saveAuthToken };
